import { render } from "./TextContentModalComponent.vue?vue&type=template&id=0ed3e339&scoped=true"
import script from "./TextContentModalComponent.vue?vue&type=script&lang=js"
export * from "./TextContentModalComponent.vue?vue&type=script&lang=js"

import "./TextContentModalComponent.vue?vue&type=style&index=0&id=0ed3e339&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed3e339"]])

export default __exports__